import { render, staticRenderFns } from "./groupCall.vue?vue&type=template&id=157f683e&lang=pug"
import script from "./groupCall.vue?vue&type=script&lang=js"
export * from "./groupCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports